import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'capitalizeFirst'
})
export class CapitalizeFirstPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (value === null || value === undefined) {
            return value;
        }
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

}



// WEBPACK FOOTER //
// ./src/app/common/pipes/capitalize-first.pipe.ts